import styles from "./NoIncidentsBackground.module.scss"

export const NoIncidentsBackground = () => {
  return (
    <div className={styles.aurora}>
      <div className={styles.auroraStrip}></div>
      <div className={styles.auroraStrip}></div>
      <div className={styles.auroraStrip}></div>
      <div className={styles.auroraStrip}></div>
      <div className={styles.auroraStrip}></div>
    </div>
  )
}
